export default "__VITE_ASSET__IedKKL5N__"